import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcChangeLog = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M2.856 15.476a1 1 0 0 1 1.345.435A8.5 8.5 0 1 0 11.344 3.54a1 1 0 1 1-.101-1.997c4.84-.246 9.36 2.9 10.665 7.771 1.501 5.601-1.823 11.359-7.424 12.86-4.87 1.305-9.856-1.037-12.063-5.35a1 1 0 0 1 .435-1.347Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M2.326 13.502a1 1 0 0 1-1.05-.948 10.425 10.425 0 0 1 .037-1.54 1 1 0 1 1 1.99.194c-.04.41-.05.826-.029 1.245a1 1 0 0 1-.948 1.05ZM2.8 8.736a1 1 0 0 1-.455-1.339c.205-.418.439-.822.698-1.209a1 1 0 1 1 1.662 1.113c-.21.313-.4.64-.566.98a1 1 0 0 1-1.339.455Zm2.628-3.854a1 1 0 0 1 .231-1.395 10.35 10.35 0 0 1 1.316-.801 1 1 0 0 1 .911 1.78 8.428 8.428 0 0 0-1.063.648 1 1 0 0 1-1.395-.232Z",
  fill: "var(--mds-nav-icon-medium)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm-1-7a1 1 0 0 0 .293.707l1.5 1.5a1 1 0 0 0 1.414-1.414L13 11.586V8.5a1 1 0 1 0-2 0V12Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcChangeLog");

export { IcChangeLog };
//# sourceMappingURL=ic-change-log.js.map
